import styled from 'styled-components'

export const SkeletonBoard = () => {
  return (
    <SContainer>
      <SHeader>
        <STags>
          <SkeletonBlock width="100px"
            height="24px"
          />
        </STags>

        <SkeletonBlock width="200px"
          height="32px"
        />

        <SkeletonBlock width="200px"
          height="32px"
        />

        <SkeletonBlock width="200px"
          height="32px"
        />
      </SHeader>

      <SSection>
        <SkeletonBlock width="120px"
          height="24px"
          $marginBottom="24px"
        />

        <SBoardsGrid>
          {[...Array(6)].map((_, index) => (
            <SBoardCard key={index}>
              <SkeletonBlock width="100%"
                height="120px"
              />
            </SBoardCard>
          ))}
        </SBoardsGrid>
      </SSection>

      <SSection>
        <SkeletonBlock width="120px"
          height="24px"
          $marginBottom="24px"
        />

        <SAssetsGrid>
          {[...Array(8)].map((_, index) => (
            <SAssetCard key={index}>
              <SkeletonBlock width="100%"
                height="160px"
              />
            </SAssetCard>
          ))}
        </SAssetsGrid>
      </SSection>
    </SContainer>
  )
}

const SkeletonBlock = styled.div<{ width: string; height: string; $marginTop?: string; $marginBottom?: string }>`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  width: ${props => props.width};
  height: ${props => props.height};
  margin-top: ${props => props.$marginTop || '0'};
  margin-bottom: ${props => props.$marginBottom || '0'};

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`

const SContainer = styled.div`
  padding: 0 24px;
`

const SHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const STags = styled.div`
  display: flex;
  gap: 8px;
`

const SSection = styled.div`
  margin-top: 40px;
`

const SBoardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 24px;
`

const SAssetsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(362px, 1fr));
  gap: 24px;
`

const SBoardCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`

const SAssetCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`
